import { axios } from '@/lib/axios';
import { OutputErrorLog } from '@/lib/error';

export type ProcessingShapeReport = {
  id: number;
  siteId: number;
  createStatusId: number;
  createdAt?: Date;
  updatedAt?: Date;
};

export const getProcessingShapesReports = async ({
  siteId,
  isPublic,
}: {
  siteId: number;
  isPublic: boolean;
}): Promise<ProcessingShapeReport | null> => {
  try {
    const { data } = await axios.get<ProcessingShapeReport>(
      `/sites/${siteId}/processing-shapes/reports`,
      {
        params: {
          isPublic,
        },
      }
    );
    return data;
  } catch (error) {
    OutputErrorLog('getProcessingShapesReports', error);
    return null;
  }
};
